module.exports = __webpack_public_path__ + "img/blog-logo.8c4c10f1.jpg";